export class BackupRegionsFilters {
    'containsAllOf';
    'containsAnyOf';
    'containsNoneOf';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "containsAllOf",
            "baseName": "containsAllOf",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "containsAnyOf",
            "baseName": "containsAnyOf",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "containsNoneOf",
            "baseName": "containsNoneOf",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupRegionsFilters.attributeTypeMap;
    }
    constructor() {
    }
}
